module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/235-tokelau-cadf2590322660ce0b0043219e34575d.svg";